import { GST_RATE_LABEL } from "../../../../config/gst.config";
import { formatCurrency } from "../../../../components/QuoteTable/utils";

export interface OverallTotalsSummaryProps {
	subtotal: number;
	gst: number;
	totalcost: number;
}

/**
 * Footer "Total" panel under the per-quote tables on BidderQuoteTab.
 * Pure presentational — caller computes the figures.
 */
export const OverallTotalsSummary = ({
	subtotal,
	gst,
	totalcost,
}: OverallTotalsSummaryProps): JSX.Element => (
	<div className="mb-10 flex h-[64px] items-center justify-start overflow-hidden rounded-xl border border-solid border-[#EAECF0] bg-white shadow-lg">
		<div className="h-full content-center border-l-4 border-[#003CE9] pl-10 font-roboto text-[18px] font-semibold text-primary-900">
			Total
		</div>
		<div className="ml-auto h-full content-center border-l border-solid border-[#EAECF0] pl-6 pr-20">
			<div className="font-roboto text-[12px] font-medium text-primary-900">
				Subtotal
			</div>
			<div
				className="font-roboto font-medium"
				style={{ color: "#D0D5DD" }}
			>
				{formatCurrency(subtotal)}
			</div>
		</div>
		<div className="h-full content-center border-l border-solid border-[#EAECF0] pl-6 pr-20">
			<div className="font-roboto text-[12px] font-medium text-primary-900">
				{GST_RATE_LABEL}
			</div>
			<div
				className="font-roboto font-medium"
				style={{ color: "#D0D5DD" }}
			>
				{formatCurrency(gst)}
			</div>
		</div>
		<div className="h-full content-center border-solid border-[#EAECF0] bg-royal-blue2 pl-6 pr-20">
			<div
				className="font-roboto text-[12px] font-medium"
				style={{ color: "#D0D5DD" }}
			>
				Total Cost
			</div>
			<div className="font-roboto font-medium text-white">
				{formatCurrency(totalcost)}
			</div>
		</div>
	</div>
);
